import type { ConnectionInventory } from "@nlkb/api-contract/connections";

import { visiblePairedConnections } from "./connection-pairing";

export const HEADER_CONNECTION_NUDGE_DISMISSED_PREFIX =
  "nlkb.header-connection-nudge-dismissed.";

export function headerConnectionNudgeStorageKey(
  organizationId: string,
  principalId: string,
): string {
  return `${HEADER_CONNECTION_NUDGE_DISMISSED_PREFIX}${organizationId}.${principalId}`;
}

export function principalHasAssignedConnection(
  connections: readonly ConnectionInventory[],
  principalId: string,
): boolean {
  return visiblePairedConnections(connections).some(
    (connection) => connection.owner_principal_id === principalId,
  );
}

export function shouldShowHeaderConnectionNudge(input: {
  readonly connections: readonly ConnectionInventory[];
  readonly principalId: string;
  readonly dismissed: boolean;
}): boolean {
  if (input.dismissed) return false;
  return !principalHasAssignedConnection(input.connections, input.principalId);
}

export function readHeaderConnectionNudgeDismissed(
  organizationId: string,
  principalId: string,
): boolean {
  try {
    return (
      window.localStorage.getItem(
        headerConnectionNudgeStorageKey(organizationId, principalId),
      ) === "1"
    );
  } catch {
    return false;
  }
}

export function persistHeaderConnectionNudgeDismissed(
  organizationId: string,
  principalId: string,
): void {
  try {
    window.localStorage.setItem(
      headerConnectionNudgeStorageKey(organizationId, principalId),
      "1",
    );
  } catch {
    // Ignore quota and private-mode failures.
  }
}
